import { message, Upload, UploadProps } from 'antd';
import { RcFile } from 'antd/lib/upload';
import { beforeImageUploadValidator } from 'modules/donor/utils/before-image-upload-validator';
import { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { envServices } from 'utils/EnvServices';
import { getAccessToken } from 'utils/getAccessToken';

type PropTypes = {
  action?: string;
} & UploadProps;

const UploadDonorPhoto: FC<PropTypes> = ({
  data,
  action = 'upload',
  onChange,
  ...restProps
}) => {
  const token = getAccessToken();
  const { t } = useTranslation('donor.UploadDonorPhoto');
  const [showUploadList, setShowUploadList] = useState(true);

  const beforeUpload = async (file: RcFile) => {
    try {
      return await beforeImageUploadValidator(file, t);
    } catch (err: any) {
      message.error(err.message);
      return Upload.LIST_IGNORE;
    }
  };

  const handleChange: UploadProps['onChange'] = (info) => {
    onChange?.(info);
    if (info.file.status === 'done') {
      setShowUploadList(false);
    }
    if (info.file.status === 'uploading') {
      setShowUploadList(true);
    }
  };

  const defaultProps: UploadProps = {
    name: 'file',
    maxCount: 1,
    action: `${envServices.get('SERVER_URI')}/donor/${action}`,
    headers: {
      authorization: token ? `Bearer ${token}` : '',
    },
    data,
    accept: 'image/*',
    onChange: handleChange,
    showUploadList,
    beforeUpload,
  };

  return <Upload {...restProps} {...defaultProps} />;
};

export default UploadDonorPhoto;
